var map = {
	"./burningbird.ts": 130,
	"./burningship.ts": 131,
	"./example.ts": 132,
	"./julia.ts": 133,
	"./magnet1.ts": 134,
	"./magnet2.ts": 135,
	"./mandelbrot.ts": 136,
	"./mandelbrot3.ts": 137,
	"./mandelbrot4.ts": 138,
	"./newton.ts": 139,
	"./nova.ts": 140,
	"./novacomplex.ts": 141,
	"./novatan.ts": 142,
	"./phoenix.ts": 143,
	"./pickover.ts": 144,
	"./pickover2.ts": 145,
	"./secant.ts": 146,
	"./tippetts.ts": 147,
	"./tricorn.ts": 148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;